import { GetLoadables } from './loader';
// #if process.env.UIX_CHUNKED === 'true'
let loader = ()=>{
    return import(/* webpackChunkName: 'dmp' */ './dmpLoad');
};
let { DmpViewBasic } = GetLoadables(loader, [
    'DmpViewBasic'
]);
// #endif
// #if process.env.UIX_CHUNKED === 'false'
// import {DmpViewBasic} from './dmpLoad'
// #endif
export { DmpViewBasic };
